// extracted by mini-css-extract-plugin
module.exports = {"list":"letterLinksNav_list__ivdGl","brandon-grey":"letterLinksNav_brandon-grey__v3JgJ"};